import React from 'react';
import { PARTNERS } from '../data/mock';

const PartnersSection = () => {
  const doubled = [...PARTNERS, ...PARTNERS];
  return (
    <section className="py-16 md:py-20 bg-white border-t border-slate-100">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-10">
          <h2 className="heading-display text-3xl md:text-4xl font-bold text-slate-900">Our Partners</h2>
          <div className="mx-auto mt-4 flex items-center justify-center gap-1">
            <span className="w-8 h-0.5 bg-[#F97559]" />
            <span className="w-2 h-2 rounded-full bg-[#F97559]" />
            <span className="w-8 h-0.5 bg-[#F97559]" />
          </div>
        </div>
      </div>
      <div className="overflow-hidden">
        <div className="marquee-track flex gap-12 w-max items-center">
          {doubled.map((p, i) => (
            <div key={i} className="h-20 w-44 grid place-items-center shrink-0 px-4">
              <img src={p} alt="partner" className="max-h-16 max-w-full object-contain opacity-70 hover:opacity-100 transition-opacity grayscale hover:grayscale-0" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
